import React from 'react';

export default function School({ size, color }) {
  return (
    <svg width={size} height={size} fill={color} viewBox='0 0 24 24'>
      <path d='M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z' />
    </svg>
  );
}
